<template>
  <b-container>
    <div v-if="!showCustomerManagement">
      <el-dialog
        :before-close="closeDialog"
        :close-on-click-modal="false"
        :title="title"
        :visible.sync="dialogVisible"
      >
        <!-- <b-spinner v-show="bMostraSpinner" label="Spinning"></b-spinner> -->
        <Loading :active="bMostraSpinner" :is-full-page="true"></Loading>
        <el-form>
          <el-form-item
            v-if="showProjectName"
            :label="uniTranslation('S1080') + (mandatoryFields ? ' *' : '')"
            :label-width="'250px'"
          >
            <el-input
              v-model="project.name"
              autocomplete="off"
              @keyup.enter="setDialogResultTrue"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="uniTranslation('PHE10107') + ': ' + (mandatoryFields ? ' *' : '')"
            :label-width="'250px'"
          >
            <el-input
              v-model="project.title"
              autocomplete="off"
              @keyup.enter="setDialogResultTrue"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="uniTranslation('PHE10102') + ': ' + (mandatoryFields ? ' *' : '')"
            :label-width="'250px'"
          >
            <el-input
              v-model="project.description"
              autocomplete="off"
              @keyup.enter="setDialogResultTrue"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="showCustomerSelection"
            :label="uniTranslation('GO035')"
            :label-width="'250px'"
          >
            <el-select v-model="rtCustomerId" placeholder="..." filterable>
              <el-option
                v-for="item in listaClienti"
                :key="item.id"
                :label="item.companyName + ', ' + item.attention"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="setDialogResultFalse">{{ uniTranslation("S128") }}</el-button>

          <el-button type="primary" :disabled="denyConfirm" @click="saveProject">{{
            uniTranslation(saveButtonLabel)
          }}</el-button>

          <el-button
            v-if="enableSaveProjectAs && false"
            type="primary"
            :disabled="denyConfirm"
            @click="saveProjectAs"
            >{{ uniTranslation("PHE107") }}</el-button
          >
        </span>
      </el-dialog>
    </div>
  </b-container>
</template>

<script>
import { Dialog, Form, FormItem, Input, Button, Select, Option } from "element-ui";
import projectService from "../../services/backend/projectService";
import { mapGetters } from "vuex";
import { Notification /*, Message*/ } from "element-ui";
import offerteservice from "@/services/backend/offersService";

import Loading from "vue-loading-overlay";

export default {
  name: "ProjectDetails",

  components: {
    "el-dialog": Dialog,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-input": Input,
    "el-button": Button,
    "el-select": Select,
    "el-option": Option,
    Loading
  },

  props: {
    project: {
      type: Object,
      defalut: null
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    showProjectName: {
      type: Boolean,
      default: false
    },
    enableSaveProject: {
      type: Boolean,
      default: false
    },
    enableSaveProjectAs: {
      type: Boolean,
      default: false
    },
    showCustomerSelection: {
      type: Boolean,
      default: false
    },
    mandatoryFields: {
      type: Boolean,
      default: false
    },
    saveButtonLabel: {
      type: String,
      default: "S332"
    }
  },
  data() {
    return {
      dialogResult: false,
      showCustomerManagement: false,
      rtCustomerId: 0,
      rtCustomer: "",
      rtCustomerContact: "",
      rtCustomerEmail: "",
      listaClienti: [],
      bMostraSpinner: false
    };
  },

  computed: {
    ...mapGetters(["projects"]),
    denyConfirm() {
      if (this.mandatoryFields) {
        if (this.showProjectName) {
          if (!this.project.name) {
            return true;
          }
        }
        if (!this.project.title) {
          return true;
        }
        if (!this.project.description) {
          return true;
        }
        if (this.showCustomerSelection) {
          if (this.rtCustomerId <= 0) {
            return true;
          }
        }
      }
      return false;
    }
  },

  watch: {
    rtCustomerId: function(nv, ov) {
      if (nv !== ov && nv) {
        this.aggiornaClienteSelezionato();
      }
    }
  },

  mounted: function() {
    var that = this;
    if (this.showCustomerSelection) {
      //offerteservice.getUserCustomers().then(function(data) { // 18.05.2020 => Hanno Richiesto l'intera Lista e non solo quelli dell'utente!
      offerteservice.getAllUserCustomers().then(function(data) {
        that.listaClienti = data;

        /*
          Antonio C
          17/07/2020

          Criterio di ordinamento:
            "item.companyName + ', ' + item.attention"
        */

        that.listaClienti.sort(function(a, b) {
          var keyA = a.companyName + ", " + a.attention,
            keyB = b.companyName + ", " + b.attention;

          if (keyA) {
            keyA = keyA.toLowerCase();
          }

          if (keyB) {
            keyB = keyB.toLowerCase();
          }

          // Compare the 2 dates
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });

        that.rtCustomerId = that.listaClienti[0].id; // that.rtCustomerId = data[0].id;
      });
    }
  },

  methods: {
    impostaTitolo: function() {
      var prj = this.projects["" + this.$route.params.projectId];
      const title = document.getElementById("title");
      title.innerHTML = this.$t("PHETITLECALCOLO") + " - " + prj.description;
    },
    setDialogResultTrue() {
      this.setDialogResultAndClose(true);
    },
    setDialogResultFalse() {
      this.setDialogResultAndClose(false);
    },
    setDialogResultAndClose(result) {
      var that = this;
      that.dialogResult = result;
      that.closeDialog();
    },

    closeDialog: function() {
      var that = this;

      that.$emit("closeDialog", that.dialogResult);
      if (that.dialogResult) {
        that.confirm();
      }

      setTimeout(() => {
        that.bMostraSpinner = false;
      }, 1500);
    },

    confirm: function() {
      var that = this;
      that.$emit("confirm", that.dialogResult);
    },

    saveProject: function() {
      var that = this;
      //that.enableSaveProject = true;
      //alert("qui" + that.enableSaveProject);

      that.bMostraSpinner = true;

      if (that.showProjectName) {
        this.$store.dispatch("changeProjectProperty", {
          path: that.project.path + ".name",
          value: that.project.name
        });
      }
      this.$store.dispatch("changeProjectProperty", {
        path: that.project.path + ".title",
        value: that.project.title
      });
      this.$store.dispatch("changeProjectProperty", {
        path: that.project.path + ".description",
        value: that.project.description
      });
      if (that.showCustomerSelection) {
        this.$store.dispatch("changeProjectProperty", {
          path: that.project.path + ".customer",
          value: that.rtCustomer
        });
        this.$store.dispatch("changeProjectProperty", {
          path: that.project.path + ".customerContact",
          value: that.rtCustomerContact
        });
        this.$store.dispatch("changeProjectProperty", {
          path: that.project.path + ".customerEmail",
          value: that.rtCustomerEmail
        });
      }
      if (that.enableSaveProject) {
        that.setDialogResultTrue(true);
        //that.enableSaveProject = false;
        //});
      } else {
        projectService.updateProject(that.projects).then(function(data) {
          if (data != undefined) {
            that.$store.dispatch("loadProject", {
              projectId: data.projectId,
              project: data
            });
            that.setDialogResultTrue(true);
          }
        });
      }
      //console.log(that.project);
    },
    saveProjectAs: function() {
      var that = this;

      that.bMostraSpinner = true;

      if (that.showProjectName) {
        this.$store.dispatch("changeProjectProperty", {
          path: that.project.path + ".name",
          value: that.project.name
        });
      }
      this.$store.dispatch("changeProjectProperty", {
        path: that.project.path + ".title",
        value: that.project.title
      });
      this.$store.dispatch("changeProjectProperty", {
        path: that.project.path + ".description",
        value: that.project.description
      });
      if (that.showCustomerSelection) {
        this.$store.dispatch("changeProjectProperty", {
          path: that.project.path + ".customer",
          value: that.rtCustomer
        });
        this.$store.dispatch("changeProjectProperty", {
          path: that.project.path + ".customerContact",
          value: that.rtCustomerContact
        });
        this.$store.dispatch("changeProjectProperty", {
          path: that.project.path + ".customerEmail",
          value: that.rtCustomerEmail
        });
      }
      if (that.enableSaveProject) {
        projectService.saveProjectAs(that.projects).then(function(data) {
          if (data != undefined) {
            Notification.success({
              title: that.uniTranslation("S698"),
              message: that.uniTranslation("S1778")
            });
            that.$store.dispatch("loadProject", {
              projectId: data.projectId,
              project: data
            });
          } else {
            Notification.error({
              title: that.uniTranslation("S1214"),
              message: that.uniTranslation("S1440")
            });
          }
          that.setDialogResultTrue(true);
        });
      }
    },
    async aggiornaClienteSelezionato() {
      var that = this;
      await offerteservice.getCustomer(that.rtCustomerId).then(function(data) {
        var cliente = data;
        that.setCustomerInfo(cliente);
      });
    },
    setCustomerInfo(cliente) {
      var that = this;
      if (!(cliente === null) && !(cliente === undefined)) {
        that.rtCustomer = "" + cliente.companyName;
        that.rtCustomerContact = "" + cliente.attention;
        that.rtCustomerEmail = "" + cliente.email;
      }
    }
  }
};
</script>

<style lang="scss"></style>
